export default [
  {
    value: 'Assinatura',
  },
  {
    value: 'Aula',
  },
  {
    value: 'Caixa',
  },
  {
    value: 'Consulta',
  },
  {
    value: 'Dia',
  },
  {
    value: 'Entrega',
  },
  {
    value: 'Garrafa',
  },
  {
    value: 'Hora',
  },
  {
    value: 'Mês',
  },
  {
    value: 'Período',
  },
  {
    value: 'Semana',
  },
  {
    value: 'Unidade',
  },
  {
    value: 'Usuário',
  },
];
